import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import StudentAssessmentList from "../components/StudentAssessmentList";


const StudentAssessmentListPage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Students  </h5><Breadcrumb title="Students" /></div>


        <StudentAssessmentList />

    </>
  );
};


export default StudentAssessmentList;
